'use client'
import { useQuery } from '@tanstack/react-query'
import { fetchProducts } from '../services'

export const useProducts = (params: IOptionsProductProps, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['PRODUCTS_LIST', params || ''],
    queryFn: () => fetchProducts(params),
    enabled,
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 30, // 30 minutes (formerly cacheTime)
    retry: 2, // Retry failed requests 2 times
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff
  })
}
